// extracted by mini-css-extract-plugin
export default {"container":"layoutUnregistered_container__V2G9H","background":"layoutUnregistered_background__KaMec","logo":"layoutUnregistered_logo__UlqDU"};